import React, { useEffect, useState } from "react";
import {
  getAllEntertainmentVideos,
  deleteEntertainmentVideo,
} from "../../../api/entertainmentVideo.api"; // Assuming you have this API function
import AdminLayout from "../../layout/AdminLayout";
import { baseURL } from "../../../api/api";
import { BsTrash3 } from "react-icons/bs";
import { Link } from "react-router-dom";
import {
  confirmMediaDelete,
  errorMsg,
  success,
} from "../../../utils/notifications";
import { FiPlus } from "react-icons/fi";
import { RotatingLines } from "react-loader-spinner";

function EntertainmentVedios() {
  const [entertainmentVedios, setEntertainmentVedios] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllEntertainmentVideos()
      .then((res) => {
        setLoading(false);
        setEntertainmentVedios(res?.data);
        console.log("all", res?.data);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  }, []);

  const handleDelete = (id, e) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      confirmMediaDelete().then(async (result) => {
        if (result.isConfirmed) {
          await deleteEntertainmentVideo(id); // API call for deleting the entertainment video
          setEntertainmentVedios(
            entertainmentVedios.filter((vedio) => vedio._id !== id)
          );
          await success(
            "Success!",
            "Entertainment Video deleted successfully!"
          );
        }
      });
    } catch (error) {
      console.error("Error deleting video:", error);
      errorMsg("Oops", error?.response?.message);
    }
  };

  return (
    <>
      <AdminLayout title="Infotainment Videos">
        <div className="p-5">
          <div className="mb-5 flex items-center justify-end sticky top-16 bg-slate-50 py-3 z-10 px-2">
            <Link
              to="/infotainmentvideos/add"
              className="flex items-center justify-center rounded-md bg-yellowColor px-3 py-2.5 text-base font-semibold text-gray-700 shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellowColor"
            >
              <FiPlus className="text-lg text-gray-700" />
              Add Infotainment Video
            </Link>
          </div>
          {loading ? (
            <div className="flex justify-center items-center h-64">
              <RotatingLines
                strokeColor="black"
                strokeWidth="5"
                animationDuration="0.75"
                width="96"
                visible={true}
              />
            </div>
          ) : (
            <div className="gap-7 grid grid-cols-12">
              {entertainmentVedios.map((vedio, index) => (
                <Link
                  to={`/infotainmentvideos/${vedio._id}`}
                  key={index}
                  className="lg:col-span-4 md:col-span-12 col-span-12"
                >
                  <div className="bg-white border border-gray-200 rounded-lg shadow">
                    <div className="px-5 py-3 flex items-center justify-end">
                      <button
                        onClick={(e) => handleDelete(vedio._id, e)}
                        id="deleteEntetaimentVedio"
                        className="ml-3 text-xl h-8 w-8 flex items-center justify-center bg-red-100 text-red-700 px-0.5 rounded-md"
                      >
                        <BsTrash3 />
                      </button>
                    </div>
                    <video
                      className="hide-voice-control object-cover h-64 w-full"
                      alt=""
                      muted
                      controls
                    >
                      <source
                        src={`${baseURL}/s3/images/${vedio?.video?.name}`}
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                    <div className="py-5">
                      <div className="px-5 flex items-center justify-between">
                        <p className="text-xl font-semibold text-gray-700">
                          {/* Slicing the video name to 20 characters */}
                          {vedio.name.length > 20
                            ? `${vedio.name.slice(0, 20)}...`
                            : vedio.name}
                        </p>
                      </div>

                      <div className="px-5 flex items-center justify-between">
                        <p className="text-base font-semibold text-gray-600">
                          Date
                        </p>
                        <p className="text-sm font-normal text-gray-600">
                          {vedio?.startDate.split("T")[0]} -{" "}
                          {vedio?.endDate.split("T")[0]}
                        </p>
                      </div>
                      <div className="px-5 flex items-center justify-between">
                        <p className="text-base font-semibold text-gray-600">
                          Location
                        </p>
                        <p className="text-sm font-normal text-gray-600">
                          {vedio?.location}
                        </p>
                      </div>
                      <div className="px-5 flex items-center justify-between">
                        <p className="text-base font-semibod text-gray-600">
                          Category
                        </p>
                        <p
                          className={`text-sm font-semibold ${
                            vedio?.category === "Entertainment"
                              ? "text-purple-500"
                              : "text-blue-500"
                          }`}
                        >
                          {vedio?.category}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </AdminLayout>
    </>
  );
}

export default EntertainmentVedios;
